import React from 'react';

export interface LoadingSpinnerProps {
  label?: string;
  size?: 'large' | 'medium' | 'small' | 'x-large' | 'x-small';
  withBlur?: boolean;
  className?: string;
  id?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  id,
  label,
  size = 'large',
  withBlur = false,
  className = '',
}) => (
  <>
    <div
      id={id}
      className={`ui-loading-spinner ui-loading-spinner__size--${size} ${
        withBlur ? 'ui-loading-spinner__with-blur' : ''
      } ${className}`}
    >
      <div className="ui-loading-spinner__svg-wrapper">
        <svg viewBox="0 0 100 100">
          <circle
            cx="50"
            cy="50"
            r="45"
            fill="none"
            strokeMiterlimit="10"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      </div>
      {label && <div className="ui-loading-spinner__label">{label}</div>}
    </div>
    {withBlur && <div className="ui-loading-spinner__blur" />}
  </>
);

export default LoadingSpinner;
